import { render, staticRenderFns } from "./BannerWithSlot.vue?vue&type=template&id=d223d442&"
import script from "./BannerWithSlot.vue?vue&type=script&lang=ts&"
export * from "./BannerWithSlot.vue?vue&type=script&lang=ts&"
import style0 from "./BannerWithSlot.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VLayout})
